<ol>
  <a  *ngFor="let operation of undoRedoHistoryDatasource, let i = index" (click)="selectOperation(operation, i)">
    <li class="pe-4 mb-2">
      {{ getOperationDescription(operation) | translate }}
    </li>
  </a>
</ol>
